'use client';

import { useCallback } from 'react';

interface MailtoArticle {
  title: string;
  slug: string;
}

const SUPPORT_EMAIL = 'contact@softfactura.ro';

export function useContactMailto() {
  const buildMailto = useCallback((subject?: string, articles?: MailtoArticle[]) => {
    const params = new URLSearchParams();
    if (subject) params.set('subject', subject);
    if (articles && articles.length > 0) {
      const body = 'Referință articole:\n' + articles.map((a) => `- ${a.title} (${a.slug})`).join('\n');
      params.set('body', body);
    }
    const qs = params.toString();
    return `mailto:${SUPPORT_EMAIL}${qs ? '?' + qs : ''}`;
  }, []);

  const sendMail = useCallback(
    (subject?: string, articles?: MailtoArticle[]) => {
      window.location.href = buildMailto(subject, articles);
    },
    [buildMailto],
  );

  return { buildMailto, sendMail };
}
